module.exports = __webpack_public_path__ + "img/1-1.33df0f78.svg";